import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
    <React.Fragment>
        <path d="m12 2c-4.1 0-7.5 3.3-7.5 7.4s7.5 12.9 7.5 12.9 7.5-8.7 7.5-12.8-3.4-7.5-7.5-7.5zm2.6 11.3l-2.6-1.9-2.6 1.9 1-3.1-2.6-1.9h3.2l1-3 1 3h3.2l-2.6 1.9 1 3.1z" />
    </React.Fragment>
);
